import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import OutflowsMoneyFlowsSectionLayout from './OutflowsMoneyFlowsSectionLayout';
import { OutflowsMoneyFlows } from './OutflowsMoneyFlows';

const metaOverrideSet = buildFacetDesignOverride().nameOverride('moneyFlows', {
  _component: () => OutflowsMoneyFlows,
}, overrideReadOnly);

const OutflowsMoneyFlowsSection = ({ resource }) => {
  return (
    <MetaResourceRenderer
      layout={OutflowsMoneyFlowsSectionLayout}
      resource={resource}
      metaOverrideSet={metaOverrideSet}
    />
  );
};

OutflowsMoneyFlowsSection.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
OutflowsMoneyFlowsSection.defaultProps = {};

export default OutflowsMoneyFlowsSection;
